import { type RouteComponentProps } from "react-router-dom";

import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type IBillPaymentProps } from "entity/bill/BillPayment/BillPayment";

const BillPayment = lazyLoadWithRetry(() => import("entity/bill/BillPayment/BillPayment"));

interface IBillPaymentRouteParams {
    id: string;
}

interface IBillPaymentDetailRouteParams {
    billPaymentId: string;
}

export const RouteBillPayment = (
    props: Omit<IBillPaymentProps, "id" | "jobId" | "history" | "location" | "match">,
) => (
    <>
        <RouteRelative
            // exact so the 2-segment numeric route doesn't also match the 3-segment
            // /BillPayment/detail/:billPaymentId route (react-router v5 matches non-exact by
            // default and, with no Switch, would otherwise mount BOTH routes — the numeric one calling
            // handler.get(NaN) from parseInt("detail")).
            exact
            path={routes.billPayment.details}
            render={(routeProps: RouteComponentProps<IBillPaymentRouteParams>) => {
                return (
                    <BTSuspense>
                        <BillPayment
                            {...props}
                            {...routeProps}
                            id={parseInt(routeProps.match.params.id)}
                        />
                    </BTSuspense>
                );
            }}
        />
        <RouteRelative
            path={routes.billPayment.detail}
            render={(routeProps: RouteComponentProps<IBillPaymentDetailRouteParams>) => {
                const param = routeProps.match.params.billPaymentId;

                return (
                    <BTSuspense>
                        <BillPayment
                            {...props}
                            {...routeProps}
                            id={0}
                            parentBillPaymentId={parseInt(param)}
                        />
                    </BTSuspense>
                );
            }}
        />
    </>
);
